import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardService } from "./dashboard.service";
import { dashboardTimesheetDetails, RmDashboard } from "./dashboard";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { DatePipe } from "@angular/common";
import { SessionStorage } from "ngx-webstorage";
import { RequestUnlockDialogComponent } from "../../employee/dashboard-employee/request-unlock-dialog/request-unlock-dialog.component";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  public rmdashboardprojects = "0";
  public rmdashboardemployees = "0";
  public rmdashboardpendingTimesheets = "0";
  public rmRejectedTimesheets = 0;
  public rmdashboardTimesheetDetails: any = [];
  public firstDay: any;
  public lastDay: any;
  public firstDayDate: any;
  public firstDayDateCopy: any;
  public yearFirstCopy: any;
  public lastDayDateCopy: any;
  public yearLastCopy: any;
  public lastDayDate: any;
  public yearFirst: any;
  public yearLast: any;
  public sunday: any;
  public monday: any;
  public tuesday: any;
  public wednesday: any;
  public weekNumer: any;
  public thursday: any;
  public friday: any;
  public saturday: any;
  public currentDate: any;
  public currentWeak: any;
  public dailyshow: boolean;
  public weekshow: boolean = true;
  public monthshow: boolean;
  public iscurrentDay: any;
  public rmDashboard: any = new RmDashboard();
  public currentMonth: any;
  public cuurentYear: any;
  public dashboardDate: any;
  public islocked: boolean = false;
  public unlockrequesent: boolean;
  public currentMonthNo: number = new Date().getMonth();
  public totalHr: any = 0;
  public avgHr: any;
  public currentDateValue: any;
  public lockedLength: any;
  public totalHrs: any;
  public isAdherence = false;
  public isCompliance = false;
  public timesheetStatus: any;
  public hasRm: any;
  public currentMonthIndex: any;
  public pendingList = [];

  @SessionStorage() public user;
  @SessionStorage() public config;

  public monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  constructor(
    public router: Router,
    public dashboardService: DashboardService,
    public datePipe: DatePipe,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    let currentDAY = new Date();
    this.currentDate = new Date();
    this.dashboardDate = new Date().getDate();
    this.cuurentYear = currentDAY.getFullYear();
    this.currentDateValue =
      this.currentDate.getFullYear() +
      "/" +
      (this.currentDate.getMonth() + 1) +
      "/" +
      this.currentDate.getDate();
    this.getWeekDays(currentDAY);
    this.currentMonth = this.monthNames[new Date().getMonth()];
    this.currentMonthNo = new Date().getMonth();
    this.currentWeak = this.datePipe.transform(currentDAY, "ww");
    if (this.currentWeak > 52) {
      this.currentWeak = 1;
    }
    // this.monthViewInfo();
    this.getDashboard(parseInt(this.currentWeak), "W");
    this.getDashboardTimesheet();
    this.timesheetHeaderSettings();
    this.getEmployeeStatus();
    this.getPendingTimesheetDetail(false);
    this.lastDayDateCopy = this.lastDayDate;
    this.firstDayDateCopy = this.firstDayDate;
    this.yearFirstCopy = this.yearFirst;
    this.yearLastCopy = this.yearLast;
  }

  /**function to get dashboard detail */
  getDashboard(timeSpan, type) {
    this.rmDashboard.userDetails.Empno = this.user.Empno;
    this.rmDashboard.timespan = timeSpan;
    this.rmDashboard.requestType = type;
    this.rmDashboard.year = this.yearLast;
    this.dashboardService.getDashboard(this.rmDashboard).subscribe((data) => {
      this.rmdashboardprojects = data.payload.projectCount;
      this.rmdashboardemployees = data.payload.employeeCount;
      this.rmdashboardpendingTimesheets = data.payload.pendingTimesheetCount;
      this.rmRejectedTimesheets = data.payload.rejectedTimesheetCount;
      const date1 = new Date();
      const date2 = new Date(data.payload.lockStatus.lockedDetails.lockedDate);
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      this.lockedLength = Math.ceil(timeDiff / (1000 * 3600 * 24));
      this.lockedLength =
        this.lockedLength == 1
          ? this.lockedLength + " DAY"
          : this.lockedLength + " DAYS";
      if (data.payload.lockStatus.unlockRequest.Requested) {
        this.unlockrequesent = true;
      }
      if (this.config.businessUnit === "accenture") {
        if (data.payload.lockStatus.lockedDetails.isLocked) {
          this.islocked = true;
        }
      }
      if (
        this.config.businessUnit === "ipdo" ||
        this.config.businessUnit === "biologics" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        this.isAdherence = data.payload.lockStatus.lockedDetails.isLocked
          ? true
          : false;
        this.isCompliance = data.payload.lockStatus.lockedDetails
          .isNonCompliance
          ? true
          : false;
        if (this.unlockrequesent === true) {
          this.timesheetStatus = "REQUESTED FOR UNLOCK";
        } else {
          if (this.isAdherence) {
            this.timesheetStatus = "YOUR TIMESHEET IS SET TO NON ADHERENCE";
          }
          if (this.isCompliance) {
            this.timesheetStatus = "YOUR TIMESHEET IS SET TO NON COMPLIANCE";
          }
        }
      }
      this.totalHr = data.payload.currfilledHrs;
      if (this.config.businessUnit === "accenture") {
        this.totalHrs = data.payload.empwiseUtilizeHrs.totalHrs
          ? data.payload.empwiseUtilizeHrs.totalHrs
          : 0;
        this.avgHr = data.payload.empwiseUtilizeHrs.avgHrs
          ? data.payload.empwiseUtilizeHrs.avgHrs
          : 0;
      }
      if (
        this.config.businessUnit === "ipdo" ||
        this.config.businessUnit === "biologics" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        this.totalHrs = data.payload.empwiseUtilizeHrs.totalHrs
          ? data.payload.empwiseUtilizeHrs.totalHrs
          : "00:00";
        this.avgHr = data.payload.empwiseUtilizeHrs.avgHrs
          ? data.payload.empwiseUtilizeHrs.avgHrs
          : "00:00";
      }
    });
  }

  // /**function to request for unlock */
  requestunlock() {
    if (
      this.config.businessUnit != "ipdo" &&
      this.config.businessUnit != "chinateam" &&
      this.config.businessUnit != "aps"
    ) {
      if (!this.unlockrequesent) {
        if (this.dialog.openDialogs.length === 0) {
          const dialogRef = this.dialog.open(RequestUnlockDialogComponent, {
            width: "auto",
          });
          dialogRef.afterClosed().subscribe((result) => {
            this.getDashboardTimesheet();
            this.getDashboard(parseInt(this.currentWeak), "W");
          });
        }
      }
    }
  }

  calendarUpdate() {
    var self = this;
    var Cal = function (divId) {
      //Store div id
      this.divId = divId;
      // Days of week, starting on Sunday
      this.DaysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      // Months, stating on January
      this.Months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      // Set the current month, year
      var d = new Date();

      this.currMonth = d.getMonth();
      this.currYear = d.getFullYear();
      this.currDay = d.getDate();
    };

    // Goes to next month
    Cal.prototype.nextMonth = function () {
      var d = new Date();
      var currentMonthValue = d.getMonth();
      var currentYearValue = d.getFullYear();

      // if (this.currMonth < currentMonthValue && this.currYear < currentYearValue)  {
      if (this.currMonth == 11) {
        this.currMonth = 0;
        this.currYear = this.currYear + 1;
        self.currentMonthIndex = this.currMonth;
        self.cuurentYear = this.currYear;
      } else {
        this.currMonth = this.currMonth + 1;
        self.currentMonthIndex = this.currMonth;
      }
      const requestMonth = {
        month: this.currMonth,
        year: this.currYear,
      };
      self.dashboardService
        .getCalendarPendingTimesheets(requestMonth)
        .subscribe(
          (data) => {
            if (data.result) {
              self.pendingList = data.result;
              this.showcurr();
            }
          },
          (err) => {
            this.showcurr();
          }
        );
      // }
    };

    // Goes to previous month
    Cal.prototype.previousMonth = function () {
      if (this.currMonth == 0) {
        this.currMonth = 11;
        this.currYear = this.currYear - 1;
        self.currentMonthIndex = this.currMonth;
        self.cuurentYear = this.currYear;
      } else {
        this.currMonth = this.currMonth - 1;
        self.currentMonthIndex = this.currMonth;
      }

      const requestMonth = {
        month: this.currMonth,
        year: this.currYear,
      };

      self.dashboardService
        .getCalendarPendingTimesheets(requestMonth)
        .subscribe(
          (data) => {
            if (data.result) {
              self.pendingList = data.result;
              this.showcurr();
            }
          },
          (err) => {
            this.showcurr();
          }
        );
    };

    // Show current month
    Cal.prototype.showcurr = function () {
      this.showMonth(this.currYear, this.currMonth);
    };

    // Show month (year, month)
    Cal.prototype.showMonth = function (y, m) {
      var d = new Date(),
        // First day of the week in the selected month
        firstDayOfMonth = new Date(y, m, 1).getDay(),
        // Last day of the selected month
        lastDateOfMonth = new Date(y, m + 1, 0).getDate(),
        // Last day of the previous month
        lastDayOfLastMonth =
          m == 0
            ? new Date(y - 1, 11, 0).getDate()
            : new Date(y, m, 0).getDate();

      var html = "<table>";
      // Write selected month and year
      html += "<thead><tr>";
      html += '<td colspan="7">' + this.Months[m] + " " + y + "</td>";
      html += "</tr></thead>";

      // Write the header of the days of the week
      html += '<tr class="days">';
      for (var i = 0; i < this.DaysOfWeek.length; i++) {
        html += '<td class="week-name">' + this.DaysOfWeek[i] + "</td>";
      }
      html += "</tr>";

      // Write the days
      var i = 1;
      do {
        var dow = new Date(y, m, i).getDay();

        // If Sunday, start new row
        if (dow == 0) {
          html += "<tr>";
        }
        // If not Sunday but first day of the month
        // it will write the last days from the previous month
        else if (i == 1) {
          html += "<tr>";
          var k = lastDayOfLastMonth - firstDayOfMonth + 1;
          for (var j = 0; j < firstDayOfMonth; j++) {
            html += '<td class="not-current">' + k + "</td>";
            k++;
          }
        }

        // Write the current day in the loop
        var chk = new Date();
        var chkY = chk.getFullYear();
        var chkM = chk.getMonth();
        var approved = []; //2 green
        var notSubmitted = []; // unfilled red
        var rejected = []; //1 purple or blue
        var drafted = []; // "" red
        var submitted = []; // 0 yellow

        self.pendingList.forEach((element) => {
          switch (element.approvalStatus.status) {
            case 0:
              submitted.push(element.dateDetails.day);
              break;
            case 1:
              rejected.push(element.dateDetails.day);
              break;
            case 2:
              approved.push(element.dateDetails.day);
              break;
            case "":
              drafted.push(element.dateDetails.day);
              break;
            case "unfilled":
              notSubmitted.push(element.dateDetails.day);
              break;
          }
        });

        if (
          chkY == this.currYear &&
          chkM == this.currMonth &&
          i == this.currDay
        ) {
          html += '<td class="today">' + i + "</td>";
        } else {
          var className = rejected.indexOf(i) >= 0 ? "blue" : "";
          className += submitted.indexOf(i) >= 0 ? "yellow" : "";
          className += approved.indexOf(i) >= 0 ? "green" : "";
          className += drafted.indexOf(i) >= 0 ? "red" : "";
          className += notSubmitted.indexOf(i) >= 0 ? "red" : "";
          html += '<td class="normal ' + className + '">' + i + "</td>";
        }

        // If Saturday, closes the row
        if (dow == 6) {
          html += "</tr>";
        }
        // If not Saturday, but last day of the selected month
        // it will write the next few days from the next month
        else if (i == lastDateOfMonth) {
          var k = 1;
          for (dow; dow < 6; dow++) {
            html += '<td class="not-current">' + k + "</td>";
            k++;
          }
        }

        i++;
      } while (i <= lastDateOfMonth);

      // Closes table
      html += "</table>";

      // Write HTML to the div
      document.getElementById(this.divId).innerHTML = html;
    };

    // Start calendar
    var c = new Cal("divCal");

    c.showcurr();

    // Bind next and previous button clicks
    getId("btnNext").onclick = function () {
      c.nextMonth();
    };
    getId("btnPrev").onclick = function () {
      c.previousMonth();
    };

    // Get element by id
    function getId(id) {
      return document.getElementById(id);
    }
  }

  /**function to get employee detail*/
  getEmployeeStatus() {
    this.dashboardService.getLockedStatus().subscribe((data) => {
      this.hasRm = data.payload.RMCode;
    });
  }

  /**function to get timesheet detail*/
  getDashboardTimesheet() {
    const firstDayISO = new Date(this.firstDay).toISOString();
    this.dashboardService.getTimesheetDashboard(firstDayISO,this.lastDay).subscribe((data) => {
      data.payload.forEach((value) => {
        const model = new dashboardTimesheetDetails(
          value,
          this.config.businessUnit
        );
        if (model.workDetails.length > 0) {
          for (let i = 0; i < model.workDetails.length; i++) {
            if (model.workDetails[i].dayparam == this.sunday) {
              model.sunday = model.workDetails[i].totalhrs;
            } else if (model.workDetails[i].dayparam == this.monday) {
              model.monday = model.workDetails[i].totalhrs;
            } else if (model.workDetails[i].dayparam == this.tuesday) {
              model.tuesday = model.workDetails[i].totalhrs;
            } else if (model.workDetails[i].dayparam == this.wednesday) {
              model.wednesday = model.workDetails[i].totalhrs;
            } else if (model.workDetails[i].dayparam == this.thursday) {
              model.thursday = model.workDetails[i].totalhrs;
            } else if (model.workDetails[i].dayparam == this.friday) {
              model.friday = model.workDetails[i].totalhrs;
            } else if (model.workDetails[i].dayparam == this.saturday) {
              model.saturday = model.workDetails[i].totalhrs;
            }
          }
          this.rmdashboardTimesheetDetails.push(model);
        }
      });
    });
  }

  /**function to navigate project*/
  navigateToProjects() {
    this.router.navigate(["/rm/projects"]);
  }

  /**function to navigate timesheet*/
  navigateToTimesheet() {
    this.router.navigate(["/rm/approval-list"]);
  }

  /**function to navigate rejected list*/
  navigateToRejectedList() {
    this.router.navigate(["/rm/rejected-list"]);
  }

  /**function to navigate timesheet list*/
  navigateToTimesheetList() {
    this.router.navigate(["/rm/timesheet-entry"]);
  }

  /**function to get week days*/
  // getWeekDays(currentDate) {
  //   const curr = new Date(currentDate);
  //   const first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
  //   const last = first + 6; // last day is the first day + 6
  //   this.firstDay = new Date(curr.setDate(first)).toUTCString();
  //   let count = 0;
  //   const startDate = new Date(this.firstDay);
  //   while (count < 6) {
  //     this.lastDay = new Date(startDate.setDate(startDate.getDate() + 1));
  //     count++;
  //   }
  //   this.firstDayDate =
  //     new Date(this.firstDay).getDate() +
  //     " " +
  //     this.monthNames[new Date(this.firstDay).getMonth()];
  //   this.lastDayDate =
  //     new Date(this.lastDay).getDate() +
  //     " " +
  //     this.monthNames[new Date(this.lastDay).getMonth()];
  //   if (this.config.businessUnit !== "accenture") {
  //     this.firstDayDate =
  //       new Date(this.firstDay).getDate() +
  //       1 +
  //       " " +
  //       this.monthNames[new Date(this.firstDay).getMonth()];
  //     this.lastDayDate =
  //       new Date(this.lastDay).getDate() +
  //       1 +
  //       " " +
  //       this.monthNames[new Date(this.lastDay).getMonth()];
  //   }
  //   this.yearFirst = new Date(this.firstDay).getFullYear();
  //   this.yearLast = new Date(this.lastDay).getFullYear();
  //   this.weekNumer = this.datePipe.transform(startDate, "ww");
  // }

  getWeekDays(currentDate) {
    const curr = new Date(currentDate);
    let first;
    if (this.config.businessUnit === "accenture") {
      first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    } else {
      first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
    }
    this.firstDay = new Date(curr.setDate(first)).toUTCString();
    const startDate = new Date(this.firstDay);
    this.lastDay = new Date(startDate.setDate(startDate.getDate() + 6));
    this.firstDayDate =
      new Date(this.firstDay).getDate() +
      " " +
      this.monthNames[new Date(this.firstDay).getMonth()];
    this.lastDayDate =
      new Date(this.lastDay).getDate() +
      " " +
      this.monthNames[new Date(this.lastDay).getMonth()];
    this.yearFirst = new Date(this.firstDay).getFullYear();
    this.yearLast = new Date(this.lastDay).getFullYear();
    this.weekNumer = this.datePipe.transform(startDate, "ww");
  }

  /**function to config header day*/
  timesheetHeaderSettings() {
    if (this.config.businessUnit !== "accenture") {
      this.sunday = this.getDateDay(6);
    } else {
      this.sunday = this.getDateDay(0);
    }
    this.monday = this.getDateDay(0);
    this.tuesday = this.getDateDay(1);
    this.wednesday = this.getDateDay(2);
    this.thursday = this.getDateDay(3);
    this.friday = this.getDateDay(4);
    this.saturday = this.getDateDay(5);
    this.iscurrentDay = new Date().getDate();
  }

  /**function to get date and day*/
  getDateDay(number) {
    const date = new Date(this.firstDay);
    date.setDate(new Date(this.firstDay).getDate() + number);
    console.log(date, number, this.firstDay, "date");
    return date.getDate();
  }

  /**function to get previous week detail*/
  getPriviousWeek() {
    const date = new Date(this.firstDay);
    date.setDate(new Date(this.firstDay).getDate() - 3);
    this.getWeekDays(date);
    const previous = this.datePipe.transform(date, "ww");
    this.getDashboard(parseInt(previous, 10), "W");
  }

  /**function to get next week detail*/
  getNextWeek() {
    const date = new Date(this.lastDay);
    date.setDate(new Date(this.lastDay).getDate() + 1);
    this.getWeekDays(date);
    let previous = this.datePipe.transform(date, "ww");
    if (parseInt(previous, 10) > 52) {
      previous = "1";
    }
    this.getDashboard(parseInt(previous, 10), "W");
  }

  /**function to get current date*/
  getsingleDay() {
    const currentDAY = new Date();
    const curr = new Date(currentDAY);
  }

  /**function to get dashboard detail for selected day*/
  dashboardperiodSelected(period) {
    if (period == "daily") {
      this.dailyshow = true;
      this.weekshow = false;
      this.monthshow = false;
      this.getDashboard(this.currentDateValue, "D");
    } else if (period == "week") {
      this.dailyshow = false;
      this.weekshow = true;
      this.monthshow = false;
      this.getDashboard(parseInt(this.weekNumer, 10), "W");
    } else if (period == "month") {
      this.dailyshow = false;
      this.weekshow = false;
      this.monthshow = true;
      this.getDashboard(this.currentMonthNo + 1, "M");
    }
  }

  /**function to get previous month detail*/
  getPreviousMonth() {
    if (this.currentMonthNo > 0) {
      this.currentMonth = this.monthNames[this.currentMonthNo - 1];
      this.currentMonthNo = this.currentMonthNo - 1;
      this.getDashboard(this.currentMonthNo + 1, "M");
    }
  }

  /**function to get next month detail*/
  getNextMonth() {
    if (this.currentMonthNo < 11) {
      this.currentMonth = this.monthNames[this.currentMonthNo + 1];
      this.currentMonthNo = this.currentMonthNo + 1;
      this.getDashboard(this.currentMonthNo + 1, "M");
    }
  }

  /**function to get last day detal*/
  getYesterdaysDate() {
    this.currentDate.setDate(this.currentDate.getDate() - 1);
    this.currentDateValue =
      this.currentDate.getFullYear() +
      "/" +
      (this.currentDate.getMonth() + 1) +
      "/" +
      this.currentDate.getDate();
    this.getDashboard(this.currentDateValue, "D");
  }

  /**function to get next day detail*/
  getTommororwDate() {
    this.currentDate.setDate(this.currentDate.getDate() + 1);
    this.currentDateValue =
      this.currentDate.getFullYear() +
      "/" +
      (this.currentDate.getMonth() + 1) +
      "/" +
      this.currentDate.getDate();
    this.getDashboard(this.currentDateValue, "D");
  }

  getPendingTimesheetDetail(data) {
    if (!data) {
      this.monthNames.forEach((element, index) => {
        if (this.currentMonth === element) {
          this.currentMonthIndex = index;
        }
      });
    }
    const requestMonth = {
      month: this.currentMonthIndex,
      year: this.cuurentYear,
    };
    this.dashboardService.getCalendarPendingTimesheets(requestMonth).subscribe(
      (data) => {
        if (data.result) {
          this.pendingList = data.result;
          this.calendarUpdate();
        }
      },
      (err) => {
        this.calendarUpdate();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/dashboard/dashboard.component.ts